import { IntlProvider } from "react-intl";
import enUS from "../intl/messages/en-US.json";

const INTL_MESSAGES = Object.entries(enUS).reduce(
  (messages, [key, { message }]) => ({ ...messages, [key]: message }),
  {}
);

export default function IntlWrapper({ children }: React.PropsWithChildren) {
  return (
    <IntlProvider locale="en" messages={INTL_MESSAGES}>
      {children}
    </IntlProvider>
  );
}
